import fb from '@/firebaseConfig';
import { isToday } from '@/helpers/timeHelpers';
import analytics from '@/utils/Analytics';

// TODO Get new subscriber set when user subscribes
// TODO Handle remote config posts

/*

  STATE

 */

const state = {
  post: null,
  postSet: [],
  postIndex: 0,
  indexUpdatedAt: null,
  postsLoaded: false,
};

/*

  GETTERS

 */

const getters = {
  // Add any conditions that impact visibility of daily post
  showPost: (state, getters, rootState) => {
    const { welcomeSlideNum } = rootState.user;
    return welcomeSlideNum < 1;
  },
};

/*

  ACTIONS

 */

const actions = {
  // Prioritizing getting current post as quickly as possible
  // If posts already loaded for today, do nothing
  // If should show post and not updated yet today:
  //    ==> Set today's post & fetch
  //    If user doesn't have set ==> get new user set
  //    If at the end of set ==> get new set
  //    If not at the end ==> update index
  // If already updated today, or post not needed ==> set existing post data

  init({ commit, dispatch, state }, { posts, welcomeSlideNum }) {
    if (state.postsLoaded) return;

    const { postSet = [] } = posts || {};
    let { postIndex = 0, indexUpdatedAt = null } = posts || {};
    const showPost = welcomeSlideNum < 1; // Update with other conditions

    if (showPost && !isToday(indexUpdatedAt ? indexUpdatedAt.toDate() : null)) {
      postIndex += 1;
      indexUpdatedAt = fb.currentTimestamp();
      commit('setPosts', { postSet, postIndex, indexUpdatedAt });
      dispatch('getPost', postSet[postIndex]);

      if (!postSet.length) {
        dispatch('updatePostSetInDB', { indexUpdatedAt, isNewUser: true });
      } else if (postIndex === postSet.length - 1) {
        dispatch('updatePostSetInDB', { indexUpdatedAt });
      } else {
        dispatch('updateIndexInDB', { postIndex, indexUpdatedAt });
      }
    } else {
      commit('setPosts', { postSet, postIndex, indexUpdatedAt });
      dispatch('getPost', postSet[postIndex]);
      dispatch('user/saveUserInitDataToDB', { moduleName: 'posts' }, { root: true });
    }
  },

  // TODO If can't get current post, go to next
  async getPost({ commit }, postInfo = {}) {
    if (!postInfo.id) return;
    try {
      const postDoc = await fb.postsCollection.doc(postInfo.id).get();
      const { content } = postDoc.data();
      commit('setPost', { ...postInfo, content });
    } catch (error) {
      console.error('Error fetching post', error);
    }
  },

  updateIndexInDB({ dispatch }, { postIndex, indexUpdatedAt }) {
    dispatch(
      'user/saveUserInitDataToDB',
      {
        moduleName: 'posts',
        moduleData: {
          'posts.postIndex': postIndex,
          'posts.indexUpdatedAt': indexUpdatedAt,
        },
      },
      { root: true }
    );
  },

  async updatePostSetInDB(
    { dispatch, rootState },
    { indexUpdatedAt, isNewUser = false, isNewSubscriber = false }
  ) {
    const { uid } = rootState.user;
    try {
      const getNewPostSet = fb.functions.httpsCallable('post-getNewPostSet');
      const { data: newSet } = await getNewPostSet({ uid, isNewUser, isNewSubscriber });
      console.log({ newSet });
      dispatch(
        'user/saveUserInitDataToDB',
        {
          moduleName: 'posts',
          moduleData: {
            'posts.postSet': newSet,
            'posts.postIndex': 0,
            'posts.indexUpdatedAt': indexUpdatedAt,
          },
        },
        { root: true }
      );
    } catch (error) {
      console.error('Error generating new posts', error);
      analytics.exception('Error generating new posts');
    }
  },
};

/*

  MUTATIONS

 */

const mutations = {
  setPosts(state, data) {
    state.postSet = data.postSet || [];
    state.postIndex = data.postIndex || 0;
    state.indexUpdatedAt = data.indexUpdatedAt ? data.indexUpdatedAt.toDate() : null;
    state.postsLoaded = data.postSet && data.postSet.length;
  },

  setPost(state, post) {
    state.post = post;
  },

  setIndex(state, { postIndex, indexUpdatedAt }) {
    state.postIndex = postIndex;
    state.indexUpdatedAt = indexUpdatedAt;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
